
(() => {
  const setupNavbar = (header) => {
    if (!header || header.dataset.navbarReady === 'true') return;
    header.dataset.navbarReady = 'true';

    const mobileMenu = header.querySelector('.aflora-navbar__mobile-menu');
    const hideOnScroll = header.dataset.hideOnScroll === 'true';
    let lastY = window.scrollY;

    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-elevated', y > 6);

      if (!hideOnScroll) {
        lastY = y;
        return;
      }

      if (y <= 20) {
        header.classList.remove('is-hidden');
      } else if (y > lastY + 4) {
        header.classList.add('is-hidden');
        if (mobileMenu) mobileMenu.removeAttribute('open');
      } else if (y < lastY - 4) {
        header.classList.remove('is-hidden');
      }

      lastY = y;
    };

    const langPicker = header.querySelector('.aflora-navbar__lang-picker');

    document.addEventListener('click', (event) => {
      if (mobileMenu && mobileMenu.hasAttribute('open') && !mobileMenu.contains(event.target)) {
        mobileMenu.removeAttribute('open');
      }
      if (langPicker && langPicker.hasAttribute('open') && !langPicker.contains(event.target)) {
        langPicker.removeAttribute('open');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (mobileMenu && mobileMenu.hasAttribute('open')) mobileMenu.removeAttribute('open');
        if (langPicker && langPicker.hasAttribute('open')) langPicker.removeAttribute('open');
      }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
  };

  document.querySelectorAll('.aflora-navbar').forEach(setupNavbar);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.aflora-navbar').forEach(setupNavbar);
  });
})();
